export default __webpack_public_path__ + "static/media/generosityCoreValue.b3427c60.jpg";